


























import { Component, PropSync, Vue, Ref } from 'vue-property-decorator'
import {FormRowWings, InputWings} from "wings-ui-components";
import {notifyError} from "@/utils/notify-helper";

@Component({components: {FormRowWings, InputWings}})
export default class SaveTemplateDialog extends Vue {
  @Ref('validator') validator:any;
  @PropSync('show') active!: boolean;

  name = null

  async onConfirm() {
    if (!await this.validator.validate()) {
      // notifyError(null, this.validator.errors)
      return
    }
    this.$emit('confirm', this.name)
    this.name = null
    this.active = false
  }

}
